import React from 'react';
import { flow, map, filter, sortedUniq, sortBy } from 'lodash/fp';
import { useAssetAccess } from 'components/asset-access';
import useQueryString from 'hooks/useQueryString';
import { GetPractitionerOptions, AssetData, AssetsData } from 'types';

const getPractitionerOptions: GetPractitionerOptions = flow(
  filter((a: AssetData) => /^13/.test(a.productCode!)),
  sortBy<AssetsData>('productCode'),
  map<AssetData, string>(a => `productcodes_${a.productCode}`),
  sortedUniq,
);

export function usePractitionerOptionFilters() {
  const queryString = useQueryString();
  const { assets, hasPractitionerAllAccess } = useAssetAccess();

  return React.useMemo(
    () =>
      queryString.outofplan === 'yes' || hasPractitionerAllAccess
        ? []
        : getPractitionerOptions(assets || []),
    [assets, hasPractitionerAllAccess, queryString],
  );
}
